<template>
	<div class="boxWrapper" >
		<div class="questionTitle" v-if="questionNum==''">
			{{name}}小朋友的测评<span class="icon fr wenhao" @click="show()" style="color: #F48BA3;">&#xe6d2;</span>
		</div>
		<div class='question-top' v-if="questionNum!=''">
		  <div class='process'>
		    <div class='now' v-bind:style="{width:((bai+1)/questionNum)*100+'%'}"></div>
		  </div>
		  <div class='num-info fl' style='margin-left:0.20rem;'>已答{{bai}}题 / 共{{questionNum}}题</div>
		  <!--<span class='icon fr wenhao' @click="show()">&#xe6d2;</span>-->
		</div>
		<div class="model-question" v-bind:class="ziti==true?'active':''">
			<div class="question-wrapper" style='background:#fff'>
				<div class='question-ul clearfix' v-bind:style="{width:sWidth+'rem',left:cLeft+'rem'}">
					<div class='fl question-left-wrapper' v-for="(li,index) in sQuestion.question" v-if="sQuestion.question_type_id==2 || sQuestion.question_type_id==6 || sQuestion.question_type_id==19">
						<div class='question-top-box' style="border-radius: 6px;">
							<div class='img-box' v-bind:class="lis.choosed==1?'active':''" v-for="(lis,zindex) in li.option" @click="chooseimg(index,zindex)">
								<img v-bind:src="photo+lis.material" style='width:100%;height:100%;' />
							</div>
						</div>
					</div>

					<div class='fl question-left-wrapper' v-for="(li,index) in sQuestion.question" v-if="sQuestion.question_type_id==5">
						<div class='double-quesitonsucai'>
							<div class='dobule-imgbox'>
								<img v-bind:src="photo+li.material_stem[0].material" style='width:100%;height:100%;' />
							</div>
							<div class='double-choosebox'>
								<div class='sucai-choose' v-for="(lis,optionindex) in li.option" @click="chooseImg(index,optionindex)" v-bind:class="lis.choosed==true?'active':''">
									<img v-bind:src="photo+lis.material" style='width:100%;height:100%;' />
								</div>
							</div>

						</div>
					</div>
					<div class='fl question-left-wrapper relative' v-for="li in sQuestion.question" v-if="sQuestion.question_type_id==18">
						<canvas id="canvas1"></canvas>
						<canvas id="canvas"></canvas>
						<div class='double-quesitonsucai'>
							<div class="lianBoxWrapper container">
								<div style="width:2.4rem;height: 80vh;">
									<div class="content-box">
											<img :src="photo+img.material" class="content content-left" v-for="img in li.material_stem" :style="{width:li.material_stem.length>4?'2rem':'2.4rem'}"/>
									</div>
								</div>
								<div style="width:2.4rem;height: 80vh;">
									<div class="content-box">
											<img :src="photo+img.material" class="content content-right" v-for="img in li.option" :style="{width:li.option.length>4?'2rem':'2.4rem'}"/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class='fl question-left-wrapper' v-for="li in sQuestion.question" v-if="sQuestion.question_type_id==3">
						<div class='double-quesitonsucai' v-for="(lis,zindex) in li.option">
							<div class='dobule-imgbox'>
								<img v-bind:src="photo+lis.material" style='width:100%;height:100%;' />
							</div>
						</div>
					</div>
					<div class='fl question-left-wrapper' v-for="(li,index) in sQuestion.question" v-if="sQuestion.question_type_id==17">
						<div class="clearfix sevenwrapper" v-if="!(li.option.length==16 || li.option.length==25 || li.option.length==9)">
							<img class="typesevenimg" :src="photo+lis.material" v-for="(lis,optionindex) in li.option" :class="{'active':lis.choosed}" @click="chooseimg(index,optionindex)" />
						</div>
						<div class="clearfix" style="padding:.8rem 0" v-if="li.option.length==16 || li.option.length==25">
							<img class="typesevenimg fl" style="width: 1.5rem;margin-left: 0.3rem;" :src="photo+lis.material" v-for="(lis,optionindex) in li.option" :class="{'active':lis.choosed}" @click="chooseimg(index,optionindex)" />
						</div>
						<div class="clearfix" style="padding:.8rem 0" v-if="li.option.length==9">
							<img class="typesevenimg fl" style="width: 8rem;margin-left: 0.375rem;" :src="photo+lis.material" v-for="(lis,optionindex) in li.option" :class="{'active':lis.choosed}" @click="chooseimg(index,optionindex)" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="questionWrapper box clearfix" v-bind:style="{marginLeft:left+'rem',width:width+'rem'}">
			<div class="questionList box" v-for="(li,index) in question">
				<div class="timuWrapper box">
					<p class="timuDesc">题目</p>
					<p class="tiganDesc" style="padding-bottom: 0.15rem;">{{li.text_stem}}</p>
					<div class="mediaBox" v-if="li.question_type_id==4">
						<p v-for="(m,mIndex) in sQuestion.material_stem" v-if="m.first_id==2">
							<span v-bind:class="m.play==true?'active':''" @click="play(mIndex)">
								<i class="play icon">&#xe634;</i>
								<i class="pause icon">&#xe630;</i>
								<!--<img class="play" style="width: 100%;" src="../assets/play.png"/>
								<img class="pause" src="../assets/pause.png"/>-->
							</span>
						</p>
						<p v-for="(m,mIndex) in sQuestion.material_stem" v-if="m.first_id==1 && sQuestion.material_stem.length>1">
							<img @click="clickImg($event)" class="smallImg" :src="photo+m.material" />
						</p>
						<p v-for="(m,mIndex) in sQuestion.material_stem" v-if="m.first_id==1 && sQuestion.material_stem.length==1">
							<img @click="clickImg($event)" class="bigImg" :src="photo+m.material" style="width: 100%;" />
						</p>
					</div>
				</div>
				<div v-if="li.question_type_id==21">
					<div class="noteWrapper box">
						<textarea style="display: block;height: 1rem;font-size: .3rem;" placeholder="点击输入" v-model="li.desc"></textarea>
					</div>
					<p class="specialQuestionBtn" @click="chooseWD($event,index)">提交</p>
				</div>
				<p class="enterChild" @click="enterChild()" v-if="li.question_type_id!=1&&li.question_type_id!=4 && li.question_type_id!=21">进入选择</p>
				<ul class="xuanxiangBox box relative" v-if="li.question_type_id==1||li.question_type_id==4">
					<li class="clearfix box" v-bind:class="lis.choosed==true?'active':''" @click="chooseQuestion($event,index,optionIndex)" v-for="(lis,optionIndex) in li.option">
						<span class="fl">{{lis.text_option}} </span>
						<span class="fr choose"></span>
						<div class="absolute sp" :style="{top: li.option.length*0.76 + 0.76 + 'rem'}" @click.stop="kong()" v-if="lis.description && lis.description!='null' && lis.choosed">
							<p class="noteTitile" style="margin-top: 0.3rem;font-size: .3rem;">{{lis.description}}</p>
							<div class="noteWrapper box">
								<textarea style="display: block;height: 1rem;font-size: .3rem;" placeholder="点击输入" v-model="lis.desc"></textarea>
							</div>
							<p class="specialQuestionBtn" @click="chooseQuestion1($event,index,optionIndex)">提交</p>
						</div>
					</li>
				</ul>
				<div class="noteWrapper box" v-if="li.instruction!=null">
					<p class="noteTitile">答题说明</p>
					<p class="noteDesc">{{li.instruction}}</p>
				</div>

			</div>
		</div>
		<BigImg v-if="showImg" @clickit="divImg" :imgSrc="imgSrc"></BigImg>
		<div class="bottomBtn bottom-operate" v-if="sQuestion.question_type_id==5&& index!=0&&ziti==false" style="z-index: 2;">
			<div  @click="prev()">
				<p class="icon iconBtn">&#xe8ef;</p>
				<div class="btn-desc">上一题</div>
			</div>
		</div>
		<div class="bottomBtn bottom-operate" v-if="sQuestion.question_type_id!=5" style="z-index: 2;">
			<div class="clearfix" v-if="(sQuestion.question_type_id==1 || sQuestion.question_type_id==4 || sQuestion.question_type_id==21 || sQuestion.question_type_id==11) && index==0">
				<div @click="nextQuestion()">
					<p class="icon iconBtn">&#xe765;</p>
					<div class="btn-desc">跳过</div>
				</div>
			</div>
			<div class="clearfix" v-if="(sQuestion.question_type_id==1 || sQuestion.question_type_id==4 || sQuestion.question_type_id==21 || sQuestion.question_type_id==11) && index!=0">
				<div class="tuichu fl" @click="prev()">
					<p class="icon iconBtn">&#xe8ef;</p>
					<div class="btn-desc">上一题</div>
				</div>
				<div class="back fl" @click="nextQuestion()">
					<p class="icon iconBtn">&#xe765;</p>
					<div class="btn-desc">跳过</div>
				</div>
			</div>
			<div class="clearfix" v-if="(sQuestion.question_type_id==2 || sQuestion.question_type_id==3 || sQuestion.question_type_id==5 || sQuestion.question_type_id==6 || sQuestion.question_type_id==19|| sQuestion.question_type_id==17) && ziti==false">
				<div  @click="prev()">
					<p class="icon iconBtn">&#xe8ef;</p>
					<div class="btn-desc">上一题</div>
				</div>
			</div>
			<div class="clearfix" v-if="(sQuestion.question_type_id==2 || sQuestion.question_type_id==3 || sQuestion.question_type_id==6|| sQuestion.question_type_id==19 || sQuestion.question_type_id==17|| sQuestion.question_type_id==18) && ziti==true">
				<div class="clearfix" v-if="sQuestion.question_type_id==3 || sQuestion.question_type_id==2 || sQuestion.question_type_id==17">
					<div class="tuichu fl"  @click="renshi(0)">
						<p class="icon iconBtn">&#xe765;</p>
						<div class="btn-desc">跳过</div>
					</div>
					<div class="back fl" @click="renshi(1)">
						<p class="icon iconBtn">&#xe656;</p>
						<div class="btn-desc" v-if="sQuestion.question_type_id==3">认识</div>
						<div class="btn-desc" v-if="sQuestion.question_type_id==2 || sQuestion.question_type_id==17">确定</div>
					</div>
				</div>
				<div class="clearfix" v-if="sQuestion.question_type_id==18">
					<div class="tuichu fl" @click="getQuestion()">
						<p class="icon iconBtn">&#xe765;</p>
						<div class="btn-desc">跳过</div>
					</div>
					<div class="back fl" @click="getQuestion()">
						<p class="icon iconBtn">&#xe656;</p>
						<div class="btn-desc">确定</div>
					</div>
				</div>
				<div class="clearfix" v-if="sQuestion.question_type_id==6 || sQuestion.question_type_id==19">
					 <div style='position:absolute;top:-0.4rem;' class='btn-desc'>如果宝宝不认识，无需勉强，点击跳过按钮跳过此题</div>
					    <div class='fl tuichu' style='width:1.14rem;border:none;'  @click="renshi(0)">
					       <p class="icon iconBtn">&#xe765;</p>
						   <div class="btn-desc">跳过</div>
					    </div>
					    <div class='fl tuichu' v-if="sPlay==false" @click="playaudio()" style='width:1.14rem;border:none;margin-left:1.90rem;'>
					      <p class="icon iconBtn">&#xe634;</p>
					      <div class='btn-desc'>播放</div>
					    </div>
					    <div class='fl tuichu' v-if="sPlay==true" @click="pauseaudio()" style='width:1.14rem;border:none;margin-left:1.90rem;'>
					       <p class="icon iconBtn">&#xe630;</p>
					      <div class='btn-desc'>暂停</div>
					    </div>

					    <div class='fr back' style='width:1.14rem;border:none;' @click="renshi(1)">
					      <img src="../assets/true.png" style='margin-left:0.20rem;'>
					      <div class='btn-desc' >确定</div>
					    </div>
				</div>
			</div>
		</div>
		<div class="model" v-if="showModel">
			<div class="model-box" v-if="modelType=='wen'">
				<div class="relative">
					<img src="../assets/model.png" style="margin-bottom: 0.1rem;" />
					<p class="model-text" style="font-weight: 900;">为确保测评准确</p>
					<p class="model-text" style="text-align: left;font-size: 0.28rem;line-height: 0.5rem;">{{note}}</p>
					<p class="model-text" style="text-align: left;font-size: 0.28rem;line-height: 0.5rem;">相信您愿意帮助身边更多的父母了解孩子的成长状况！</p>
					<div class="model-btn-box" style="display:flex;justify-content:center;margin-bottom:0.2rem;">
						<p class="model-btn agin" style="width: 2.44rem;" @click="hideModel()">明白了</p>
					</div>
				</div>
			</div>
			<div class="model-box" v-if="modelType=='tuichu'" style="margin-top: 4rem;">
				<div class="relative">
					<img src="../assets/model.png" style="margin-bottom: 0.1rem;height: 1.2rem;" />
					<p class="model-text">退出之后，您再次进入</p>
					<p class="model-text">即可从这里继续测评</p>
					<div class="model-btn-box" style="display:flex;justify-content:space-around;margin-bottom:0.4rem;padding:0 0.13rem">
						<div class="model-btn agin" style="width: 2rem;" @click="hideModel()">取消</div>
						<p class="model-btn repeat" style="width: 2rem;" @click="tuichu()">确定</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import BigImg from '../components/largephoto.vue'
	export default {
		data() {
			return {
				photo: photoUrl,
				left: 0,
				showImg: false,
				imgSrc: '',
				showModel: false,
				modelType: '',
				number: '',
				user_id: '',
				openid: '',
				sIndex: 0, //当前子题下坐标
				index: 0, //当前题下坐标
				question: [], //所有题目
				sQuestion: '', //当前题的信息
				width: 7.5,
				btn: true,
				ziti: true,
				cLeft: 0,
				sWidth: 7.5,
				sPlay:false,
				note:'',
				bai:'',
				questionNum:'',
				insituation:'',
				flag:false
			}
		},
		created: function() {
			this.ziti = false;
			this.number = this.$route.params.number;
			this.note = sessionStorage.getItem('note');
			if(localStorage.getItem('user') == null || localStorage.getItem('user') == undefined) {
				this.$router.push({
					name: 'login'
				});
			} else {
				if(this.$route.params.isdiaoyan){
					if(this.$route.params.openid){
						this.openid = this.$route.params.openid
					}else{
						this.openid = '';
					}
				}else{
					this.openid = JSON.parse(localStorage.getItem('user')).children.data[0].openid;
					this.name = JSON.parse(localStorage.getItem('user')).children.data[0].name;
				}
				this.user_id = JSON.parse(localStorage.getItem('user')).openid;
			}

			if(this.number == undefined) {
				this.$router.push({
					name: 'scalarinfo'
				});
			}
			this.insituation = sessionStorage.getItem('insituation');
			var audio = document.getElementById('audio');
			var that = this;
			audio.addEventListener("ended", function(event) {
				console.log(!that.sQuestion.material_stem)
				if(that.sQuestion.material_stem){
					for(var i = 0; i < that.sQuestion.material_stem.length; i++) {
						that.sQuestion.material_stem[i].play = false;
						Vue.set(that.sQuestion.material_stem, i, that.sQuestion.material_stem[i]);
					}
				}
				that.sPlay =false;
			}, false);
			this.startQuestion()
			this.questionNumF();
		},
		mounted: function() {},
		filters: {},
		methods: {
			kong(){

			},
			questionNumF(){
				var that = this;
				http.get('assesses/progress/'+this.number).then(function(res){
					that.questionNum = res.data.question;
					that.bai=res.data.answer
				})
			},
			startQuestion() {
				var that = this;
				if(this.openid){
					var url = 'institutions/'+this.insituation+'/questions?openid='+this.openid+'&number='+this.number;
				}else{
					var url = 'institutions/'+this.insituation+'/questions?number='+this.number;
				}
				http.get(url).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
						that.question.push(res.data.question);
						that.sQuestion = res.data.question;
						that.sWidth = that.sQuestion.question.length * 7.5;
						that.calulateQuestion();
					}

				})
			},
			chooseimg:function(index,zindex){
				if(this.sQuestion.question_type_id==19){
					for(var i=0;i<this.sQuestion.question[index].option.length;i++){
						if(i==zindex){
							continue;
						}
						this.sQuestion.question[index].option[i].choosed = false;
					}
				}
				if(this.sQuestion.question[index].option[zindex].choosed){
					this.sQuestion.question[index].option[zindex].choosed = false;
				}else{
					this.sQuestion.question[index].option[zindex].choosed = true;
				}
				Vue.set(this.sQuestion.question,index,this.sQuestion.question[index]);
			},
			calulateQuestion: function() {
				this.width = (this.question.length + 1) * 7.5;
			},
			getQuestion(flag){
				if(this.sQuestion.question[0].material_stem.length != line.sumData.length && flag){
					alert1('请完善答案');
					return;
				}
				var that =this;
				var question = [];
				var sortData = line.sumData.sort(compare('leftIndex'));
				var chronography = parseInt((new Date().getTime() - this.startTime)/1000);
				for(var i=0;i<sortData.length;i++){
					question.push({
						question_id: this.sQuestion.question[0].id,
						material_id: this.sQuestion.question[0].option[sortData[i].rightIndex].material_id,
						chronography:chronography
					})
				}
				http.post('answers?question_id=' + this.sQuestion.id + '&number=' + this.number + '&openid=' + this.openid + '&question=' + JSON.stringify(question)).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
						if(!(that.index+1<that.question.length)){
						  that.question.push(res.data.question);
						  that.sQuestion = res.data.question;
						}else{
						  that.sQuestion = that.question[that.index+1];
						}
						// that.question.push(res.data.question);
						// that.sQuestion = res.data.question;
						that.sWidth = that.sQuestion.length * 7.5;
						that.endChild();
						that.next();
						that.questionNumF()
					}
				}).catch(function(res) {
					console.log(res);
				})
			},
			chooseWD($evnet,index){
				if(!this.btn) {
					return;
				}
				this.btn = false;
				var that = this;
				var question = [];
				var id = that.question[index].id
				question.push({
					text_option: that.question[index].desc?that.question[index].desc:'',
					question_id: id
				})
				if(this.openid){
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&openid=' + this.openid + '&question=' + JSON.stringify(question);
				}else{
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&question=' + JSON.stringify(question)
				}
				http.post(url).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
						if(!(that.index+1<that.question.length)){
						  that.question.push(res.data.question);
						  that.sQuestion = res.data.question;
						}else{
						  that.sQuestion = that.question[that.index+1];
						}
						// that.question.push(res.data.question);
						// that.sQuestion = res.data.question;
						that.sWidth = that.sQuestion.question.length * 7.5;
						that.next();
						that.questionNumF();
					}

				})
			},
			chooseQuestion($event, index, optionIndex) {
				if(!this.btn) {
					return;
				}
				this.btn = false;
				var that = this;
				var next = true;
				for(var i = 0; i < that.question[index].option.length; i++) {
					if(i == optionIndex) {
						that.question[index].option[i].choosed = true;
						if(that.question[index].option[i].description!='null' && that.question[index].option[i].description){
							next = false;
						}
					} else {
						that.question[index].option[i].choosed = false;
					}
				}
				Vue.set(that.question, index, that.question[index]); //更新页面显示状态
				if(!next){
					this.btn = true;
					return;
				}
				var question = [];
				var id = that.question[index].id
				question.push({
					text_option: that.question[index].option[optionIndex].text_option,
					question_id: id
				})
				if(this.openid){
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&openid=' + this.openid + '&question=' + JSON.stringify(question);
				}else{
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&question=' + JSON.stringify(question)
				}
				http.post(url).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
            if(!(that.index+1<that.question.length)){
              that.question.push(res.data.question);
              that.sQuestion = res.data.question;
            }else{
              that.sQuestion = that.question[that.index+1];
            }
						// that.question.push(res.data.question);
						// that.sQuestion = res.data.question;
						that.sWidth = that.sQuestion.question.length * 7.5;
						that.next();
						that.questionNumF();
					}

				})
			},
			chooseQuestion1($event, index, optionIndex) {
				if(!this.btn) {
					return;
				}
				this.btn = false;
				var that = this;
				Vue.set(that.question, index, that.question[index]); //更新页面显示状态
				var question = [];
				var id = that.question[index].id;
				console.log(that.question[index].option[optionIndex].desc);
//				return;
				question.push({
					text_option: that.question[index].option[optionIndex].text_option,
					question_id: id,
					remark:that.question[index].option[optionIndex].desc?that.question[index].option[optionIndex].desc:''
				})
				if(this.openid){
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&openid=' + this.openid + '&question=' + JSON.stringify(question);
				}else{
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&question=' + JSON.stringify(question)
				}
				http.post(url).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
            if(!(that.index+1<that.question.length)){
              that.question.push(res.data.question);
              that.sQuestion = res.data.question;
            }else{
              that.sQuestion = that.question[that.index+1];
            }
						// that.question.push(res.data.question);
						// that.sQuestion = res.data.question;
						that.sWidth = that.sQuestion.question.length * 7.5;
						that.next();
						that.questionNumF();
					}

				})
			},
			renshi: function(id) {
				var that = this;
				if(id == 1) {
					var that = this;
					if(this.sQuestion.question[this.sIndex].option[0].choosed) {
						console.log(1)
						this.sQuestion.question[this.sIndex].option[0].choosed = false;
					} else {
						this.sQuestion.question[this.sIndex].option[0].choosed = true;
					}
				} else {
					this.sQuestion.question[this.sIndex].option[0].choosed = false;
				}
				if(this.sIndex == this.sQuestion.question.length-1) {
					that.nextChildQuestion();
				}else{
					this.nextChlid();
				}
			},
			chooseImg(index, optionindex) {
				var that = this;
				if(this.sQuestion.question[index].option[optionindex].choosed) {
					this.sQuestion.question[index].option[optionindex].choosed = false;
				} else {
					this.sQuestion.question[index].option[optionindex].choosed = true;
				}
				Vue.set(this.sQuestion.question[index].option, optionindex, this.sQuestion.question[index].option[optionindex]); //更新页面显示状态
				if(index == this.sQuestion.question.length - 1) {
					that.nextChildQuestion()
				} else {
					this.nextChlid();
				}
			},
			nextChildQuestion() {
				var that =this;
				var question = [];
				for(var i = 0; i < this.sQuestion.question.length; i++) {
					for(var j = 0; j < this.sQuestion.question[i].option.length; j++) {
						if(this.sQuestion.question[i].option[j].choosed) {
							question.push({
								question_id: this.sQuestion.question[i].option[j].question_id,
								material_id: this.sQuestion.question[i].option[j].material_id
							})
						}
					}
				}
				if(this.openid){
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + this.sQuestion.id + '&number=' + this.number + '&openid=' + this.openid + '&question=' + JSON.stringify(question);
				}else{
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + this.sQuestion.id + '&number=' + this.number + '&question=' + JSON.stringify(question)
				}
				http.post(url).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
						if(!(that.index+1<that.question.length)){
						  that.question.push(res.data.question);
						  that.sQuestion = res.data.question;
						}else{
						  that.sQuestion = that.question[that.index+1];
						}
						// that.question.push(res.data.question);
						// that.sQuestion = res.data.question;
						that.sWidth = that.sQuestion.length * 7.5;
						that.endChild();
						that.next();
						that.questionNumF()
					}
				}).catch(function(res) {
					console.log(res);
				})
			},
			nextChlid() {
				this.sIndex = this.sIndex + 1;
				this.cLeft = this.sIndex * (-7.5);
				var audio = document.getElementById('audio');
				audio.pause();
				this.sPlay =false;
			},
			enterChild() {
				this.ziti = true;
				this.sIndex = 0;
				this.cLeft = 0;
				this.sWidth = 7.5 * this.sQuestion.question.length;
				if(this.sQuestion.question_type_id==18){
					this.startTime = new Date().getTime();
					line.init($('.container'));
				}
			},
			endChild() {
				this.ziti = false;
				this.sIndex = 0;
				this.cLeft = 0;
				this.sWidth = 7.5;
				var audio = document.getElementById('audio');
				audio.pause();
				this.sPlay =false;
			},
			prev() {
				if(this.index != 0) {
					this.index = this.index - 1;
					this.sQuestion = this.question[this.index];
          this.question.slice(0,this.index+1);
					this.sWidth = this.sQuestion.question.length * 7.5;
					this.left = this.index * (-7.5);
					// this.bai = this.bai - 1;
				}
			},
			nextQuestion() {
				if(!this.btn) {
					return;
				}
				this.btn = false;
				var that = this;
				var id = that.question[this.index].id;
				that.question[this.index].desc = '';
				var question = [];
				question.push({
					text_option: '',
					question_id: id
				})
				if(this.openid){
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&openid=' + this.openid + '&question=' + JSON.stringify(question);
				}else{
					var url = 'institutions/'+this.insituation+'/answers?question_id=' + id + '&number=' + this.number + '&question=' + JSON.stringify(question)
				}
				http.post(url).then(function(res) {
					if(res.data.message == 'Already finished') {
						that.finish();
					} else {
						if(!(that.index+1<that.question.length)){
						  that.question.push(res.data.question);
						  that.sQuestion = res.data.question;
						}else{
						  that.sQuestion = that.question[that.index+1];
						}
						// that.question.push(res.data.question);
						// that.sQuestion = res.data.question;
						that.next();
						that.questionNumF()
					}

				})
			},
			finish() {
				if(this.flag){
					return;
				}
				this.flag = true;
				$.DialogByZ.Alert({
					Title: "提示",
					Content: "题已答完，正在生成报告...",
					BtnL: "确定",
					FunL: confirmL
				})
				var that = this;
				function confirmL() {
					if(that.openid){
						var url  = 'institutions/'+that.insituation+'/reports?number='+that.number+'&user_id='+that.user_id+'&openid='+that.openid;
					}else{
						var url = 'institutions/'+that.insituation+'/reports?number='+that.number+'&user_id='+that.user_id;
					}
					http.post(url).then(function(res){
						if(res.status==201){
							$.DialogByZ.Close();
							if(sessionStorage.getItem('insituation') == 2648713){
								that.$router.push({name:"thank"});
							}else{
								var link = sessionStorage.getItem('link')+'/index.html';
								window.location.href = toResult+link+'?number='+that.number+"&userid="+that.user_id+"&openid="+that.openid;
							}
						}
					})
				}
			},
			play: function(index) {
				var audio = document.getElementById('audio');
				if(!this.sQuestion.material_stem[index].play) {
					this.sQuestion.material_stem[index].play = true;
					audio.src = photoUrl + this.sQuestion.material_stem[index].material;
					audio.load();
					audio.play();
				} else {
					this.sQuestion.material_stem[index].play = false;
					audio.pause();
				}
				for(var i = 0; i < this.sQuestion.material_stem.length; i++) {
					Vue.set(this.sQuestion.material_stem, i, this.sQuestion.material_stem[i]);
				}
			},
			playaudio(){
				var audio = document.getElementById('audio');
				if(!this.sQuestion.question[this.sIndex].material_stem[0].play){
					this.sQuestion.question[this.sIndex].material_stem[0].play = true;
					audio.src = photoUrl + this.sQuestion.question[this.sIndex].material_stem[0].material;
					audio.load();
					audio.play();
					this.sPlay =true;
				}else{
					this.sQuestion.question[this.sIndex].material_stem[0].play = false;
					audio.pause();
				}
			},
			pauseaudio(){
				var audio = document.getElementById('audio');
				this.sQuestion.question[this.sIndex].material_stem[0].play = false;
//				Vue.set(this.sQuestion.question,this.sIndex,this.sQuestion.question[this.sIndex]);
				audio.pause();
			},
			next() {
				this.calulateQuestion();
				this.index = this.index + 1;
				this.left = this.index * (-7.5);
				this.btn = true;
				var audio = document.getElementById('audio');
				audio.pause();
				this.sPlay =false;
			},
			clickImg(e) {
				this.showImg = true;
				// 获取当前图片地址
				this.imgSrc = e.currentTarget.src;
			},
			divImg() {
				this.showImg = false;
			},
			show() {
				this.showModel = true;
				this.modelType = 'wen';
			},
			hideModel: function() {
				this.showModel = false;
			},
			tuichu() {
				this.$router.push({
					name: 'scalarinfo'
				})
			},
			showTuichu() {
				this.showModel = true;
				this.modelType = 'tuichu';
			}
		},
		components: {
			BigImg
		},
		mounted: function() {},

	}
</script>

<style scoped>
	.sp{
		left: 0;
		width: 100%;
	}
	.bottomBtn {
		position: fixed;
		bottom: 1px;
		left: 0.20rem;
		width: 7.10rem;
		border: 1px solid #31c5d2;
		border-radius: 5px;
		height: 1.28rem;
		background: #fff;
	}

	.tuichu {
		width: 3.54rem;
		border-right: 1px solid #31c5d2;
	}

	.bottom-operate img {
		height: 0.76rem;
		width: 0.76rem;
		margin: 0 auto;
		margin-top: 0.10rem;
		margin-left: 1.36rem;
	}

	.bottom-operate .btn-desc {
		line-height: 0.28rem;
		font-size: 0.20rem;
		color: #31c5d2;
		font-weight: 700;
		text-align: center;
	}
	.sevenwrapper{
		padding: .2rem;
		display: flex;
        justify-content: space-between;
	}
	.btn-desc {
		margin-top: 0.1rem;
	}
	i{
		font-style: normal;
	}
	.back {
		width: 3.52rem;
	}

	.boxWrapper {
		width: 100%;
		overflow-x: hidden;
		background: url(../assets/questionbg.png);
		background-size: cover;
		background-color: rgba(0, 0, 0, 0.1);
	}

	.questionTitle {
		position: fixed;
		left: 0;
		top: 0;
		height: 0.6rem;
		width: 100%;
		line-height: 0.6rem;
		font-size: 0.3rem;
		color: #31c5d2;
		text-align: center;
		background: RGBA(245, 234, 255, 0.8);
	}

	.wenhao {
		margin-right: 0.4rem;
	}

	.questionWrapper {
		height: 100vh;
		overflow-x: hidden;
		transition: all 0.2s ease-in;
	}

	.questionList {
		float: left;
		width: 7.5rem;
		padding-top: 1.2rem;
		padding-left: 0.2rem;
		padding-right: 0.2rem;
		padding-bottom: 1.48rem;
	}

	.timuWrapper {
		width: 100%;
		border-radius: 5px;
		background: #fff;
		padding: 0.16rem 0;
		border: 1px solid #ccc;
	}

	.timuDesc {
		line-height: 0.44rem;
		font-size: 0.32rem;
		color: #666666;
		padding: 0 0.44rem;
		margin-bottom: 0.14rem;
		font-weight: 700;
	}

	.tiganDesc {
		padding: 0 0.44rem;
		line-height: 0.42rem;
		font-size: 0.3rem;
		color: #666666;
	}

	.xuanxiangBox {
		width: 100%;
		padding: 0.38rem 0.3rem 0.38rem 0.3rem;
		background: #fff;
		border-radius: 5px;
		border: 1px solid #ccc;
		margin-top: 0.64rem;
	}

	.xuanxiangBox li {
		line-height: 0.46rem;
		font-size: 0.28rem;
		color: #666666;
		border-bottom: 1px solid #eee;
		padding: 0 0.18rem;
		margin-bottom: 0.3rem;
	}

	.xuanxiangBox li.active .choose {
		background: #31c5d2;
	}

	.choose {
		width: 0.22rem;
		height: 0.22rem;
		display: inline-block;
		border: 2px solid #31c5d2;
		border-radius: 50%;
		margin-top: 0.1rem;
	}

	.noteWrapper {
		width: 100%;
		padding: 0.2rem 0.42rem;
		background: #fff;
		border: 1px solid #ccc;
		border-radius: 5px;
		margin-top: 0.3rem;
	}

	.noteTitile {
		line-height: 0.44rem;
		font-size: 0.32rem;
		color: #666;
	}

	.noteDesc {
		line-height: 0.34rem;
		font-size: 0.24rem;
		color: #666;
		margin-top: 0.2rem;
	}

	.enterChild {
		margin: 0 auto;
		margin-bottom: 0.9rem;
		margin-top: 0.9rem;
		width: 2rem;
		height: 0.64rem;
		line-height: 0.64rem;
		color: #fff;
		background: #31c5d2;
		border-radius: 5px;
		font-size: 0.3rem;
		text-align: center;
	}
	.content{
		width: 2.4rem;border: 1px solid #31c5d2;
	}
	.content-box{
		width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: space-between;
	}
	.container{
		width: 100%;height: 80vh;display: flex;justify-content: space-between;
	}
	canvas{
		position: absolute;
		left: 0;
		top: 0;
	}
	.mediaBox {
		display: flex;
		justify-content: space-around;
		border-top: 1px solid #999999;
		align-items: center;
		padding-top: 0.2rem;
	}

	.mediaBox span {
		height: 0.8rem;
		width: 0.8rem;
		display: block;
		font-size: .6rem;
		color: #31c5d2;
	}

	.mediaBox span .pause {
		display: none;
	}

	.mediaBox span .play {
		display: block;
	}

	.mediaBox span.active .pause {
		display: block;
	}

	.mediaBox span.active .play {
		display: none;
	}

	.mediaBox .smallImg {
		width: 1.6rem;
		height: 1.2rem;
	}

	.mediaBox .bigImg {
		width: 100%;
		height: auto;
	}

	.model {
		position: fixed;
		height: 100vh;
		width: 100%;
		background: RGBA(0, 0, 0, 0.1);
		top: 0;
		left: 0;
	}

	.model-box {
		margin-top: 2.00rem;
		margin-left: 0.96rem;
		width: 5.60rem;
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
	}

	.model-box img {
		width: 100%;
		height: 1.20rem;
		margin-bottom: 0.20rem;
	}

	.model-text {
		padding-top: 0.20rem;
		line-height: 0.60rem;
		color: RGBA(67, 67, 67, 0.8);
		text-align: center;
		padding-left: 0.26rem;
		padding-right: 0.26rem;
		font-size: 0.38rem;
	}

	.model-btn-box {
		margin-top: 0.46rem;
		padding-left: 0.40rem;
		padding-right: 0.40rem;
		display: flex;
		justify-content: space-between;
	}

	.model-btn {
		line-height: 0.60rem;
		text-align: center;
		font-size: 0.28rem;
		color: #fff;
		border-radius: 0.06rem;
		width: 1.78rem;
	}

	.agin {
		background: #31c5d2;
	}

	.repeat {
		background: #31c5d2;
	}

	.icon-chahao {
		right: 0.12rem;
		top: 0.12rem;
		font-size: 0.36rem;
		color: #fff;
	}

	.question-ul {
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		transition: left 0.2s ease-in;
	}

	.question-left-wrapper {
		width: 7.50rem;
	}

	.question-top {
		position: fixed;
		height: 0.60rem;
		line-height: 0.60rem;
		color: #31c5d2;
		background: RGBA(49,197,210,.5);
		text-align: center;
		font-size: 0.28rem;
		top: 0;
		left: 0;
		width: 100%;
		font-weight: 700;
		z-index: 3
	}

	.icon-yiwen {
		font-size: 0.30rem;
		color: #F5889F;
		margin-right: 0.30rem;
	}

	.question-title-wrapper,
	.question-desc {
		margin-top: 1.20rem;
		margin-left: 0.20rem;
		width: 6.22rem;
		padding-bottom: 0.20rem;
		padding-top: 0.20rem;
		background: #fff;
		border-radius: 5px;
		padding-left: 0.44rem;
		padding-right: 0.44rem;
		border: 1px solid RGBA(204, 204, 204, 1);
		margin-bottom: 0.20rem;
	}

	.question-title-wrapper {
		padding-left: 0rem;
		padding-right: 0rem;
		padding-bottom: 0rem;
		width: 7.10rem;
	}

	.titile-top {
		line-height: 0.42rem;
		font-size: 0.32rem;
		color: RGBA(102, 102, 102, 0.8);
		font-weight: 700;
		margin-bottom: 0.16rem;
	}

	.titile-content {
		line-height: 0.40rem;
		font-size: 0.32rem;
		color: RGBA(102, 102, 102, 0.8);
	}

	.zan-children {
		line-height: 0.28rem;
		font-size: 0.20rem;
		color: #31c5d2;
		margin-bottom: 0.20rem;
		padding-left: 0.26rem;
		font-weight: 700;
	}

	.option-wrapper {
		width: 6.50rem;
		margin-left: 0.20rem;
		border: 1px solid RGBA(204, 204, 204, 1);
		border-radius: 5px;
		padding-left: 0.30rem;
		padding-right: 0.30rem;
		padding-top: 0.36rem;
		padding-bottom: 0.06rem;
		background: #fff;
		margin-bottom: 1.10rem;
	}

	.option-list {
		border-bottom: 1px solid #EEEEEE;
		padding-bottom: 0.6rem;
		padding-left: 0.26rem;
		padding-right: 0.26rem;
		line-height: 0.40rem;
		color: #666;
		font-size: 0.28rem;
		margin-bottom: 0.30rem;
	}

	.zimu {
		margin-right: 0.20rem;
	}

	.choose-status {
		display: inline-block;
		height: 0.22rem;
		width: 0.22rem;
		border-radius: 50%;
		border: 1px solid #31c5d2;
		background: #fff;
		margin-top: 0.10rem;
	}

	.choose-status.active {
		background: #31c5d2;
	}

	.question-desc {
		margin-top: 0;
	}

	.bottom-operate {
		position: fixed;
		bottom: 1px;
		left: 0.20rem;
		width: 7.10rem;
		border: 1px solid #31c5d2;
		border-radius: 5px;
		height: 1.28rem;
		background: #fff;
	}

	.tuichu {
		width: 3.54rem;
		border-right: 1px solid #31c5d2;
	}

	.bottom-operate img {
		height: 0.76rem;
		width: 0.76rem;
		margin: 0 auto;
		margin-top: 0.10rem;
		margin-left: 1.36rem;
	}

	.bottom-operate .btn-desc {
		line-height: 0.28rem;
		font-size: 0.20rem;
		color: #31c5d2;
		font-weight: 700;
		text-align: center;
	}

	.back {
		width: 3.52rem;
	}

	.sucai-box {
		display: flex;
		justify-content: space-around;
		/* height: 120rem; */
		border-top: 1px solid RGBA(153, 153, 153, 1);
	}

	.sucai-box img {
		height: 0.76rem;
		width: 0.76rem;
		margin-top: 0.22rem;
	}

	.model-question.active {
		top: 0;
	}

	.model-question {
		background: #fff;
		position: fixed;
		left: 0;
		top: -100%;
		width: 100%;
		height: 100vh;
		z-index: 2;
		transition: all 0.2s ease-in;
	}

	.question-top-box {
		padding-top: 0.10rem;
		padding-left: 0.12rem;
		padding-right: 0.12rem;
		display: flex;
		flex-wrap: wrap;
	}
	.img-box.active{
		border: 1px solid blue;
	}
	.img-box {
		border-radius: 6px;
		width: 2.34rem;
		margin-top: 0.6rem;
		/*border: 1px solid #ccc;*/
		margin-right: 0.04rem;
	}

	.img-box img {
		border-radius: 6px;
	}

	.img-box.active {
		border: 1px solid #31c5d2;
	}

	.double-quesitonsucai {
		margin-top: 0.60rem;
		padding: 0.20rem;
		padding-bottom: 0;
	}

	.double-quesitonsucai.active {
		border: 1px solid #31c5d2;
	}

	.dobule-imgbox {
		height: 5.32rem;
		width: 100%;
		border-radius: 6px;
	}

	.double-choosebox {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	.typesevenimg{
		width: .8rem;
	    height: .8rem;
	    margin-top: .2rem;
	    border: 2px solid #ccc;
	    box-sizing: border-box;
	}
	.typesevenimg.active{
		border: 2px solid #31c5d2;
	}
	.sucai-choose {
		height: 2.60rem;
		width: 3.46rem;
		border-radius: 6px;
		margin-top: 0.20rem;
	}

	.enter-child {
		width: 2.00rem;
		height: 0.64rem;
		border-radius: 5px;
		background: RGBA(255, 192, 113, 1);
		color: #fff;
		text-align: center;
		line-height: 0.64rem;
		font-size: 0.30rem;
		font-weight: 700;
		margin-left: 2.52rem;
		margin-top: 0.40rem;
		margin-bottom: 0.32rem
	}

	.model {
		position: fixed;
		height: 100vh;
		width: 100%;
		background: RGBA(0, 0, 0, 0.1);
		top: 0;
		left: 0;
		z-index: 10;
	}

	.model-box {
		margin-top: 2.00rem;
		margin-left: 0.96rem;
		width: 5.60rem;
		/* height: 600rem; */
		background: #fff;
		border-radius: 0.08rem;
		overflow: hidden;
	}

	.model-box image {
		width: 100%;
		height: 2.40rem;
		margin-bottom: 0.20rem;
	}

	.model-text {
		padding-top: 0.20rem;
		line-height: 0.60rem;
		color: RGBA(67, 67, 67, 0.8);
		text-align: center;
		padding-left: 0.26rem;
		padding-right: 0.26rem;
	}

	.model-btn-box {
		margin-top: 0.46rem;
		padding-left: 0.40rem;
		padding-right: 0.40rem;
		display: flex;
		justify-content: space-between;
	}

	.model-btn {
		line-height: 0.60rem;
		text-align: center;
		font-size: 0.28rem;
		color: #fff;
		border-radius: 0.06rem;
		width: 1.78rem;
	}

	.agin {
		background: #31c5d2;
	}

	.repeat {
		background: #31c5d2;
	}

	.icon-chahao {
		right: 0.12rem;
		top: 0.12rem;
		font-size: 0.36rem;
		color: #fff;
	}

	.process {
		float: left;
		width: 4.00rem;
		background: #fff;
		border-radius: 0.50rem;
		height: 0.30rem;
		margin-top: 0.15rem;
		margin-left: 0.20rem;
		position: relative;
	}

	.now {
		position: absolute;
		left: 0;
		height: 100%;
		width: 50%;
		background: #31c5d2;
		border-radius: 0.50rem;
	}

	.num-info {
		font-size: 0.24rem;
		color: #333;
	}
	.iconBtn{
	    margin-top: 5px;
	    line-height: .76rem;
	    text-align: center;
	    font-size: .6rem;
	    color: #31c5d2;
	}
	.specialQuestionBtn{
		width: 100%;
	    margin-top: 0.3rem;
	    height: 1rem;
	    line-height: 1rem;
	    color: #fff;
	    background: #31c5d2;
	    border-radius: 5px;
	    font-size: 0.4rem;
	    text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/pages/question.vue